/* Money and number formatting. Everything the customer reads as a figure
   passes through here, so PKR looks the same on every surface. */

export const pkr = new Intl.NumberFormat('en-PK', { maximumFractionDigits: 0 })

/** "612 bytes" · "84 KB" · "2.4 MB". Never "0 KB", which reads as a file
    that failed to attach rather than a small one. */
export function fileSize(bytes: number) {
  if (bytes < 1024) return `${pkr.format(bytes)} bytes`
  if (bytes < 1024 * 1024) return `${Math.round(bytes / 1024)} KB`
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`
}

/** Local convention beats a nine-digit number: "84.5 lac", "1.25 cr". */
export function shortPrice(price: number) {
  return price >= 10000000
    ? `${(price / 10000000).toFixed(2)} cr`
    : `${(price / 100000).toFixed(1)} lac`
}
